<div class="page-wrapper section-hr-direct">
    <app-left-menu [showMenu]=false></app-left-menu>
  
    <div id="main-container">
  
      <app-header [title]="title" [showHistoryButton]="true">
  
      </app-header>
      <div class="content-header"></div>
  
  
      <div class="page-content documents">
  
        <iframe id="pdfViewer1" src="" style="width: 100%;display:none" allowfullscreen="" webkitallowfullscreen=""></iframe>
        <div *ngIf="(fileExtension == '.jpg' || fileExtension == '.png' || fileExtension == '.jpeg')" class="img">
          <img [src]="attachmentData" alt="" />
        </div>
        <div *ngIf="isViewNotSupported" class="content-idmid">
          <div class="not-found">{{'Common.NotSupported'|translate}}</div>
        </div>
  
        <footer>
          <ul *ngIf="fileExtension == '.pdf'" class="document-links">
            <li>
              <a href="javascript:void(0)" (click)="openDialog()" data-toggle="modal" data-target="#email-document" class="email">
                <span>{{'Common.Email'|translate}}</span>
              </a>
            </li>
            <li>
              <a class="print" href="javascript:void(0)" (click)="printDocument()">
                <span>{{'Common.Print'|translate}}</span>
              </a>
           
            </li>
            <li>
              <a class="remove" href="javascript:void(0)" (click)="closeDocument()">
                <span>{{'Common.Close'|translate}}</span>
              </a>
            </li>
          </ul>
  
  
          <ul *ngIf="fileExtension != '.pdf'" class="document-links printDisable">
            <li>
              <a href="javascript:void(0)" (click)="openDialog()" data-toggle="modal" data-target="#email-document" class="email">
                <span>{{'Common.Email'|translate}}</span>
              </a>
            </li>
           
            <li>
              <a class="remove" href="javascript:void(0)" (click)="closeDocument()">
                <span>{{'Common.Close'|translate}}</span>
              </a>
            </li>
          </ul>
  
  
        </footer>
      </div>
    </div>
  
  
    <div class="modal fade" id="email-document" tabindex="-1" role="dialog">
      <form [formGroup]="DocumentViewForm" (ngSubmit)="submitForm(DocumentViewForm.value, DocumentViewForm.valid)">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
  
            <div class="modal-body">
           
              <div class="row">
                <div class="error-message">
                  <span *ngIf="!DocumentViewForm.controls['EmailAddress'].valid && DocumentViewForm.controls['EmailAddress'].touched">{{'Contact.EmailErrMsg'|translate}}..&emsp;</span>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-10 col-xs-offset-1 mrg-bott-10">
                  <input type="text" class="form-control" placeholder="EmailAddress" [formControl]="DocumentViewForm.controls['EmailAddress']">
                </div>
                <!--<div class="col-xs-3"><a href="javascript:void(0)" *ngIf="false" class="link-btn" (click)="changeEmailAddress()">{{'Change'|translate}}</a></div>-->
              </div>
        
              <div class="row">
                <input type="hidden" [formControl]="DocumentViewForm.controls['Id']">
                <input type="hidden" [formControl]="DocumentViewForm.controls['Type']">
              </div>
              <div class="modal-footer">
                <div *ngIf="emailSent" style="color: green;">Email successfully sent.</div>
                <button type="submit" class="btn btn-primary" [disabled]="!DocumentViewForm.valid">{{'Common.Submit'|translate}}</button>
                <button type="button" class="btn btn-primary" data-dismiss="modal">{{'Common.Close'|translate}}</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>